export const getNextFeatureStartIndex = (lastSeenIndex, featureCount) => {
	if (
		typeof lastSeenIndex !== 'string' ||
		lastSeenIndex.trim() === '' ||
		!Number.isInteger(featureCount) ||
		featureCount < 1
	) {
		return 0
	}

	const parsedIndex = Number(lastSeenIndex)

	if (
		!Number.isInteger(parsedIndex) ||
		parsedIndex < 0 ||
		parsedIndex >= featureCount
	) {
		return 0
	}

	return (parsedIndex + 1) % featureCount
}
